import { useEffect, useEffectEvent } from 'react';
import { retryDelayMs } from '../domain/retry';

/**
 * While `active`, calls `retry` on its own at `retryDelayMs` intervals, longer each time.
 * It stops as soon as `active` turns false: whatever was waiting got through.
 */
export function useAutoRetry(active: boolean, retry: () => unknown) {
  const run = useEffectEvent(retry);
  useEffect(() => {
    if (!active) return;
    let retries = 0;
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      timer = setTimeout(async () => {
        try {
          await run();
        } catch {
          // Still unreachable: the next retry comes a little later.
        }
        if (cancelled) return;
        retries += 1;
        schedule();
      }, retryDelayMs(retries));
    };
    schedule();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [active]);
}
